module.exports = __webpack_public_path__ + "static/trunks.e0f43e91.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/examples/thumbnails/trunks.png
// module id = 862
// module chunks = 73261030922168